/**
 * Events filter bar: search only. Matches M List filter bar styling.
 */
import React from "react";

export default function EventsFilterBar({
  searchInput,
  onSearchChange,
  onSearchSubmit,
  onClearAll,
  hasActiveFilters,
}) {
  return (
    <section
      className="twentytwentysix-content__section twentytwentysix-content__filter-bar twentytwentysix-content__mlist-top-filters"
      aria-label="Search events"
    >
      <form
        className="twentytwentysix-content__search-form"
        onSubmit={onSearchSubmit}
        aria-label="Search events"
      >
        <input
          type="search"
          className="twentytwentysix-content__filter-input"
          placeholder="Search events by name, location, host…"
          value={searchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search events"
        />
        <button
          type="submit"
          className="twentytwentysix-content__pill twentytwentysix-content__pill--small"
        >
          Search
        </button>
        {hasActiveFilters && (
          <button
            type="button"
            className="twentytwentysix-content__pill twentytwentysix-content__pill--outline twentytwentysix-content__mlist-clear-filters"
            onClick={onClearAll}
          >
            Clear all filters
          </button>
        )}
      </form>
    </section>
  );
}
